
/** @format */

import React, { type Ref } from 'react'
import { Collapse, Image } from 'antd'

const cx = (...classes: any[]) => classes.filter(Boolean).join(' ')

const { Panel } = Collapse

export const Wrapper = ({ margintop, className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-full', className)}
    style={{
      marginTop: margintop || '16px',
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
Wrapper.displayName = 'Wrapper'

export const AntPanelHead = ({ isload, className, style, ...props }: any & { ref?: Ref<any> }) => (
  <Panel
    key={props.key ?? 'panel'}
    header={props.header ?? ''}
    className={cx('leading-7 py-1.5 px-0', className)}
    style={{
      fontSize: isload === 'true' ? '14px' : '12px',
      fontWeight: isload === 'true' ? '700' : '600',
      color: isload === 'true' ? '#1893FF' : '#5c6470',
      ...style,
    }}
    {...props}
  />
)
AntPanelHead.displayName = 'AntPanelHead'

export const AntCollapse = ({ className, style, ref, ...props }: any & { ref?: Ref<any> }) => (
  <Collapse
    ref={ref}
    className={cx(
      'w-full !bg-white !border !border-solid !border-[#E9E9E9] !rounded-none',
      '[&_.ant-collapse-header]:!px-6 [&_.ant-collapse-header]:!py-4 [&_.ant-collapse-header]:!items-center',
      '[&_.ant-collapse-item]:!border-[#E9E9E9]',
      '[&_.ant-collapse-content-box]:!p-0',
      className
    )}
    style={style}
    {...props}
  />
)
AntCollapse.displayName = 'AntCollapse'

const Img = ({ imgHeight, imgWidth, className, style, ...props }: any & { ref?: Ref<any> }) => (
  <Image
    className={cx('relative rounded overflow-hidden object-fill', className)}
    style={{
      height: imgHeight || '170px',
      width: imgWidth || '120px',
      ...style,
    }}
    {...props}
  />
)
Img.displayName = 'Img'

const CustomMask = ({ className, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('w-[50px] h-[50px] flex rounded bg-black/70 absolute top-0 right-0 bottom-0 text-base text-white items-center justify-center z-[99999] cursor-pointer', className)}
    {...props}
  >
    {children}
  </div>
)
CustomMask.displayName = 'CustomMask'

const AntImage = ({ imgWidth, imgHeight, className, style, ...props }: any & { ref?: Ref<any> }) => (
  <Image
    className={cx('object-cover cursor-pointer hover:!opacity-100', className)}
    style={{
      width: imgWidth || '150px',
      height: imgHeight || '175px',
      ...style,
    }}
    {...props}
  />
)
AntImage.displayName = 'AntImage'

const FileWrapper = ({ width, height, className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'relative',
      '[&_.uploading]:absolute [&_.uploading]:pointer-events-none [&_.uploading]:left-0 [&_.uploading]:right-0 [&_.uploading]:w-full [&_.uploading]:h-full [&_.uploading]:opacity-0 [&_.uploading]:flex [&_.uploading]:flex-col [&_.uploading]:items-center [&_.uploading]:justify-center [&_.uploading]:bg-black/60 [&_.uploading]:text-[10px] [&_.uploading]:text-white',
      '[&_.uploading_.wrapper-btns]:flex [&_.uploading_.wrapper-btns]:items-center [&_.uploading_.wrapper-btns]:justify-center',
      '[&:hover_.uploading]:opacity-100 [&:hover_.uploading_svg]:opacity-100',
      className
    )}
    style={{
      width: width || '50px',
      height: height || '50px',
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
FileWrapper.displayName = 'FileWrapper'

const DownloadingSpinner = ({ width, className, style, ref, ...props }: any & { ref?: Ref<any> }) => (
  <img
    ref={ref}
    className={className}
    style={{
      width: width || '16px',
      height: width || '16px',
      ...style,
    }}
    {...props}
  />
)
DownloadingSpinner.displayName = 'DownloadingSpinner'

export { FileWrapper, Img, CustomMask, AntImage, DownloadingSpinner }
